import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  AnimatedView,
  Panel,
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableCol
} from "../../../components";
import Highlight from "react-highlight";
import { history } from "../../../redux/store/configureStore";
import * as qs from "query-string";
import { Link } from "react-router-dom";
import Pagination from "react-js-pagination";
import { appConfig } from "../../../config";
import {
  Button,
  FormGroup,
  InputGroup,
  FormControl,
  Alert,
  ButtonGroup,
  MenuItem,
  DropdownButton,
  Modal,
  ControlLabel,
  Row,
  Col,
} from "react-bootstrap";
import { createHashHistory } from "history";
import { Notification } from "../../../components/notifications";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import auth from "../../../services/auth";
import Switch from "react-switch";
import isEmpty from "lodash.isempty";
import Dialog from "react-bootstrap-dialog";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { withRouter } from "react-router-dom";
import { createUser } from "../../../redux/actions/accessAction";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";

class Add extends Component {
  constructor(props) {
    super(props);
    this.state = {
      msgType: "",
      alertMessage: "",
      show: false,
      path: ["Home", "Add Super Admin"],
      links: ["home","/superadmin/add"],
      disabled: false,
      userName: "",
      email: "",
      firstName: "",
      lastName: "",
      status: "Active",
      password: "",
    };
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  validate = () => {
    let status = true;

    if(this.state.userName == ''){
      this.setState({userNameError: "red"});
      status = false;
    }

    if(this.state.firstName == ''){
      this.setState({firstNameError: "red"});
      status = false;
    }

    if(this.state.lastName == ''){
      this.setState({lastNameError: "red"});
      status = false;
    }

    if(this.state.email == ''){
      this.setState({emailError: "red"});
      status = false;
    }

    return status;
  }
  handleSubmit = (e) => {
    e.preventDefault();
    let valid = this.validate();

    if(valid){
      const postData = {
        firstName : this.state.firstName,
        lastName : this.state.lastName,
        userName : this.state.userName,
        email : this.state.email,
        status : this.state.status,
      }

      if(this.state.password){
        postData.password = this.state.password;
      }

      this.props.createUser(postData, 'superadmin/add', 'POST');
    }
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.status != nextProps.status){
      if(nextProps.status){
        this.handleShow();
        this.props.clearAlert();
        this.props.renderAlert("success", nextProps.status.data.message);
        window.scrollTo(0, 0);
      }
    }

    if(this.props.error != nextProps.error){
      if(nextProps.error){
        this.handleShow();
        this.props.clearAlert();
        this.props.renderAlert("warning", nextProps.error);
        window.scrollTo(0, 0);
      }
    }

    if (nextProps.message) {
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }
  }

  handleChange = (e) => {
    if (`this.state.${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
  }
  
  render() {
    const headerTitle = "Add Super Admin";
    return (
      <div className="col-xs-12 site-list">
        
        <div className="row">
          <div className="col-xs-12">
            <BreadcrumbComponent path={this.state.path} links={this.state.links}/>
          </div>
        </div>
        <div className="panel">
          <header className="panel-heading">Add Super Admin</header>
          <div className="panel-body">
            <div className="row">
              <div className="col-xs-12">
                {this.state.show &&
                  this.state.alertMessage !== "" && (
                    <div className="col-lg-12">
                      <Alert
                        bsStyle={this.state.msgType}
                        onDismiss={this.handleDismiss}
                      >
                        <strong>{this.state.msgType}:</strong>{" "}
                        {this.state.alertMessage}
                      </Alert>
                    </div>
                  )}
              </div>
            </div>
            <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <Row>
                <form onSubmit={this.handleSubmit} autoComplete="off">
                  <Row>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formBasicUserNameText">
                      <ControlLabel>
                        {" "}
                        <span style={{ color: "red" }}>*</span> User Name
                      </ControlLabel>
                      <FormControl
                        type="text"
                        name="userName"
                        value={this.state.userName}
                        placeholder="Enter User Name"
                        onChange={this.handleChange}
                        style={{ borderColor: this.state.userNameError }}
                        autoComplete="off"
                      />
                    </FormGroup>
                    
                    <FormGroup controlId="formBasicFirstNameText">
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span> First Name
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.firstName}
                        placeholder="Enter First Name"
                        onChange={this.handleChange}
                        name="firstName"
                        style={{ borderColor: this.state.firstNameError }}
                        autoComplete="off"
                      />
                    </FormGroup>
                    <FormGroup controlId="formBasicLastNameText">
                      <ControlLabel>
                        <span style={{ color: "red" }}>*</span> Last Name
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.lastName}
                        placeholder="Enter Last Name"
                        onChange={this.handleChange}
                        name="lastName"
                        style={{ borderColor: this.state.lastNameError }}
                        autoComplete="off"
                      />
                    </FormGroup>
                    
                  </Col>
                  <Col md={6} xs={12}>
                    <ControlLabel>
                      <span style={{ color: "red" }}>*</span> Email
                    </ControlLabel>
                    <FormGroup
                      controlId="formBasicEmailText"
                    >
                      <FormControl
                        type="email"
                        value={this.state.email}
                        placeholder="Enter email"
                        onChange={this.handleChange}
                        name="email"
                        style={{ borderColor: this.state.emailError }}
                        autoComplete="off"
                      />
                    </FormGroup>
                    <FormGroup controlId="formControlsSelect">
                      <ControlLabel>Status</ControlLabel>
                      <FormControl
                        componentClass="select"
                        placeholder="Status"
                        name="status"
                        value={this.state.status}
                        onChange={this.handleChange}
                      >
                        <option value="Active">Active</option>
                        <option value="Inactive"> Inactive </option>
                      </FormControl>
                    </FormGroup>
                    <FormGroup controlId="formBasicAddressTwoText">
                      <ControlLabel>Password</ControlLabel>
                      <FormControl
                        type="password"
                        value={this.state.password}
                        placeholder="Enter Password"
                        onChange={this.handleChange}
                        name="password"
                        autoComplete="off"
                      />
                    </FormGroup>
                  </Col>
                  </Row>

                  <Row className="BtnRow">
                    <Col md={12} xs={12} className="pull-right">
                      <Button
                        bsStyle="info"
                        type="submit"
                        id="saveButton"
                        disabled={this.state.disabled}
                      >
                        Save
                      </Button>
                      <Button
                        bsStyle="default"
                        onClick={() => history.push(`/superadmin/list`)}
                      >
                        Cancel
                      </Button>
                    </Col>
                  </Row>
                </form>
              </Row>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  error: state.user.error,
	status: state.user.status,
	alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message,
});


export default withRouter(connect(mapStateToProps, { createUser, renderAlert, clearAlert })(Add));



// WEBPACK FOOTER //
// ./src/app/views/Users/SuperAdmin/Add.js